<script setup>
  import { computed, useAttrs } from "vue";

  import IcSearch from "@/assets/images/svg-component/IcSearch.vue";
  import { CloseCircle } from "@vicons/ionicons5";

  const attrs = useAttrs();
  const props = defineProps({
    value: {
      type: String,
      default: "",
    },
    isSearching: {
      type: Boolean,
    },
    placeholder: {
      type: String,
      default: "검색어를 입력해주세요.",
    },
  });
  const emits = defineEmits(["update:value", "submit", "reset"]);

  const filteredAttrs = computed(() => {
    const { class: _c, style: _s, ...rest } = attrs;
    return rest;
  });

  const updateValue = (val) => {
    emits("update:value", val);
  };
</script>

<template>
  <div class="relative w-[320px]" v-bind="filteredAttrs">
    <n-input
      class="pr-10"
      :value="props.value"
      :placeholder="placeholder"
      @update:value="updateValue"
      @keyup.enter="emits('submit')"
      title="검색어 입력"
    />
    <ui-button
      v-if="isSearching === null || isSearching === false"
      class="absolute right-0 top-0 w-[40px] min-w-[40px]"
      variant="default"
      @click="emits('submit')"
      title="검색"
      ><template #icon
        ><n-icon><IcSearch /></n-icon></template
    ></ui-button>
    <ui-button
      v-if="isSearching"
      class="absolute right-0 top-0 w-[40px] min-w-[40px]"
      variant="default"
      @click="emits('reset')"
      title="검색 취소"
      ><template #icon
        ><n-icon><CloseCircle /></n-icon></template
    ></ui-button>
  </div>
</template>
